import * as SolarIcons from 'solar-icon-set'

interface Tool {
  key: string
  label: string
  description: string
  Icon: (allProps: any) => JSX.Element
  category: 'widget' | 'overlay' | 'app' | 'page'
  href: string
}

export const TOOLS: Tool[] = [
  {
    key: 'creator-content-profile',
    label: 'Creator Content Profile',
    description:
      'Create a profile to showcase your content and connect with your audience.',
    Icon: SolarIcons.UserId,
    category: 'page',
    href: '/dashboard/pages/creator-content-profile'
  },
  {
    key: 'chat-box',
    label: 'Chat Box',
    description:
      'Use the chat box to interact with your audience in real time.',
    Icon: SolarIcons.Dialog2,
    category: 'widget',
    href: '/dashboard/widgets/chat-box'
  },
  {
    key: 'qa',
    label: 'Questions & Answers',
    description: 'Manage questions and answers from your audience.',
    Icon: SolarIcons.QuestionSquare,
    category: 'widget',
    href: '/dashboard/widgets/questions-and-answers'
  },
  {
    key: 'sticky-notes',
    label: 'Sticky Notes',
    description:
      'Create sticky notes to share important information with your audience.',
    Icon: SolarIcons.Notes,
    category: 'widget',
    href: '/dashboard/widgets/sticky-notes'
  },
  {
    key: 'rewards-rush',
    label: 'Rewards Rush',
    description: 'Create a fun and engaging rewards system for your audience.',
    Icon: SolarIcons.VideoLibrary,
    category: 'widget',
    href: '/dashboard/widgets/rewards-rush'
  },
  {
    key: 'live-translate',
    label: 'Live Translate',
    description:
      'Translate your voice in real time to communicate with your audience.',
    Icon: SolarIcons.Microphone,
    category: 'widget',
    href: '/dashboard/widgets/live-translate'
  },
  {
    key: 'shoutout',
    label: 'Shoutout',
    description:
      'Create a shoutout overlay to recognize your supporters and followers.',
    Icon: SolarIcons.HandHeart,
    category: 'widget',
    href: '/dashboard/widgets/shoutout'
  },
  {
    key: 'spotify-song-tracker',
    label: 'Spotify Song Tracker',
    description: 'Track the current song playing on your Spotify account.',
    Icon: SolarIcons.Vinyl,
    category: 'widget',
    href: '/dashboard/widgets/spotify-song-tracker'
  },
  {
    key: 'multi-streams',
    label: 'Multi Streams',
    description: '"See others\' streams in one place."',
    Icon: SolarIcons.Display,
    category: 'page',
    href: '/multi-streams'
  }
]
